import React, { ReactNode, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';

import { FlagCz, FlagDe, FlagUk } from '@/components';

export type LanguageTypes = 'en' | 'cs' | 'de';

type LanguagePickerProps = {
  currentLanguage: LanguageTypes;
  onChange: (lang: LanguageTypes) => void;
};

export const LanguagePicker: React.FC<LanguagePickerProps> = ({ currentLanguage, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (lang: LanguageTypes) => {
    onChange(lang);
    handleClose();
  };

  const flagMap: Record<LanguageTypes, ReactNode> = {
    en: <FlagUk />,
    cs: <FlagCz />,
    de: <FlagDe />,
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ svg: { width: '1.3rem', height: '1.3rem' } }}
      >
        {flagMap[currentLanguage]}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ svg: { width: '1.3rem' } }}
      >
        <MenuItem onClick={() => handleSelect('en')}>
          <FlagUk />
        </MenuItem>
        <MenuItem onClick={() => handleSelect('cs')}>
          <FlagCz />
        </MenuItem>
        <MenuItem onClick={() => handleSelect('de')}>
          <FlagDe />
        </MenuItem>
      </Menu>
    </>
  );
};
